import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_PLAN_SECTION } from '@src/constants/LeadGenerationConstants/index';

const FeeSection = ({ content }) => {
  const { amount, includedLeft, includedRight } = content;
  return (
    <section id="fees">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Program Fee And Scholarships</h2>
          <p>
            One fee. No separate charges for cloud, API usage or tools — they&apos;re part of the
            program, and we use free tiers wherever sufficient.
          </p>
        </div>
        <div className={styles.fee}>
          <div>
            <div className={styles.k}>Program fee</div>
            <div className={styles.big}>{amount}</div>
            <div className={styles.s}>Before scholarship</div>
          </div>
          <div>
            <div className={styles.k}>Free counselling call</div>
            <div className={styles.mid}>Talk to an Advisor</div>
            <div className={styles.s}>Fit, schedule and fees — an honest read before you decide.</div>
          </div>
          <div>
            <div className={styles.k}>Assured scholarships</div>
            <div className={styles.mid}>On Application</div>
            <div className={styles.s}>Scholarships worth up to ₹1,00,000 — applied on your program fee</div>
          </div>
        </div>
        <div className={styles.feeInc}>
          <h4>Included in the fee</h4>
          <div className={styles.cols}>
            <ul>
              {includedLeft.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <ul>
              {includedRight.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <PostContentCTALayout className="mt-8 sm:mt-8">
          <LeadGenerationButton text="Apply Now" buttonLocation={LEAD_GEN_PLAN_SECTION} />
        </PostContentCTALayout>
      </div>
    </section>
  );
};

export default FeeSection;
